import { AxiosResponse } from "axios";
import appConstants from "../config/app-constants";
import InitApi from "./init";

export default class PostApi {
  static _instance: PostApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new PostApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  getPosts = async (
    parentCategoryId: number,
    catTagId: number,
    type: "category" | "tag",
    productId?: number,
  ): Promise<AxiosResponse> => {
    let url = `${appConstants.apiUrl}/posts?_fields=id,title,link,excerpt,content,author,categories,tags,meta&per_page=100`;

    if (parentCategoryId) {
      url = url + `&categories[]=${parentCategoryId}`;
    }

    if (type === "category") {
      url = url + `&categories[]=${catTagId}`;
    } else if (type === "tag") {
      url = url + `&tags[0]=${catTagId}`;
    }
    if(productId){
      url = url+`&product[]=${productId}`
    }

    return this._apiSvc.get(url);
  };

  getPostsWithoutCurrency = async (parentCategoryId: number): Promise<AxiosResponse> => {
    let url = `${appConstants.apiUrl}/posts?_fields=id,title,link,excerpt,content,author,categories,tags,meta&per_page=100`;

    if (parentCategoryId) {
      url = url + `&categories[]=${parentCategoryId}`;
    }

    return this._apiSvc.get(url);
  };
}
